import { InjectionToken } from '@angular/core';
import { CaptchaAPIConfig } from './types';


/** Captch API config injection token. */
export const CAPTCHA_CONFIG = new InjectionToken<CaptchaAPIConfig>('CAPTCHA_CONFIG');
